<div class="content">
  @if (errorMessage) {
    <div class="errorMessage">{{ errorMessage }}</div>
  }
  <div class="message-container">
    <p>Updating data for frozen/approved entity</p>
  </div>
  <div class="input-container">
    <label class="input-label" for="internalNotesInput">Internal Notes:</label>
    <textarea id="internalNotesInput" rows="3" class="text-area-input" [(ngModel)]="internalNotes" placeholder="Internal Notes"></textarea>
  </div>
  <div class="button-container">
    <span class="spacer"></span>
    <button class="dialog-button primary-button" matButton="elevated" (click)="save()" [disabled]="!canSave()">Save</button>
    <button class="dialog-button warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
  </div>
</div>
